export function fillUrlGuest(path){
    return 'api/guests/' + path
}